import { StrictMode } from 'react';

import Stack from '@mui/material/Stack';
import ReactDOM from 'react-dom/client';

import { GlobalStyles } from 'theme/globalStyles';
import {
  SESSION_SCREEN,
  SessionEventEnum,
  SessionScreenEnum,
} from 'utils/events';
import { initSentry } from 'utils/sentry';

import Quote from './App';

// reportWebVitals removed for now (for feature investigation do we need it or not)
// import reportWebVitals from './reportWebVitals';

initSentry();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const gtag: Gtag.Gtag = (
  command: 'event',
  eventName: Gtag.EventNames | (string & object),
  eventParams?: Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams,
) => {
  // eslint-disable-next-line no-console
  console.log('\n    ==== gtag ====');
  // eslint-disable-next-line no-console
  console.log(JSON.stringify({
    command,
    eventName,
    eventParams,
  }, null, 4));
};

window.gtag = gtag;

const eventNavMap: Partial<Record<SessionEventEnum, typeof SESSION_SCREEN[keyof typeof SessionScreenEnum]>> = {
  [SessionEventEnum.QUOTE_RECEIVED]: SESSION_SCREEN.REVIEW_QUOTE,
  [SessionEventEnum.QUOTE_ACCEPTED]: SESSION_SCREEN.CUSTOMER_AND_VEHICLE_INFO,
  [SessionEventEnum.QUOTE_REJECTED]: SESSION_SCREEN.REQUEST_QUOTE,
  [SessionEventEnum.CUSTOMER_AND_VEHICLE_INFO]: SESSION_SCREEN.PICKUP_INFO,
  [SessionEventEnum.PICKUP_INFO]: SESSION_SCREEN.DELIVERY_INFO,
  [SessionEventEnum.DELIVERY_INFO]: SESSION_SCREEN.PAYMENT_INFO,
  [SessionEventEnum.ORDER_SUCCESS]: SESSION_SCREEN.ORDER_SUCCESS,
  [SessionEventEnum.PAYMENT_FAILURE]: SESSION_SCREEN.PAYMENT_INFO,
  [SessionEventEnum.ORDER_FAILURE]: SESSION_SCREEN.ORDER_FAILURE,
};

window.addEventListener('message', event => {
  const message = event.data;
  const nextScreen = eventNavMap[message.type as SessionEventEnum];
  if (nextScreen) {
    document.location.href = window.origin + nextScreen;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <GlobalStyles />
    <Stack
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      p={0}
      m={0}
    >
      <Quote />
    </Stack>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
